// Global
import React from 'react';
import { tv } from 'tailwind-variants';

const SkipNav: React.FC = () => {
  /*
   * Rendering
   */

  const { base } = TAILWIND_VARIANTS();

  return (
    <a
      className={base()}
      data-component="authorable/shared/site-structure/skipnav/skipnav"
      href="#content"
    >
      Skip to main content
    </a>
  );
};

export default SkipNav;

const TAILWIND_VARIANTS = tv({
  slots: {
    base: [
      'max-w-screen-xxl',
      'px-10',
      'lg:px-20',
      'left-1',
      'rounded-none',
      'sr-only',
      'top-1',
      'focus:absolute',
      'focus:bg-theme-black-800',
      'focus:flex',
      'focus:not-sr-only',
      'focus:outline-theme-brand3',
      'focus:px-4',
      'focus:py-2',
      'focus:text-white',
      'focus:underline',
      'focus:z-50',
    ],
  },
});
